export default __webpack_public_path__ + "static/media/icons8-cloud-database-100.a9ec0592.svg";